import { useState, useEffect } from "react";
import { getCurrentTenant } from "../api/server";

function useTenantDetails() {
  const [hasProvider, setHasProvider] = useState(false);
  const [providerTenant, setProviderTenant] = useState(false);
  const [providerName, setProviderName] = useState(false);
  const [isLoadingTenant, setIsLoadingTenant] = useState(false);

  useEffect(() => {
    async function getTenantDetails() {
      const tenant = await getCurrentTenant();
      const {
        microsoft_auth_provider_enabled,
        microsoft_auth_provider_tenant,
      } = tenant;
      if (microsoft_auth_provider_enabled) {
        setHasProvider(true);
        setProviderTenant(microsoft_auth_provider_tenant);
        setProviderName("microsoft.com");
      }
    }
    async function run() {
      try {
        await getTenantDetails();
      } catch (e) {
        // console.error(e);
      } finally {
        setIsLoadingTenant(false);
      }
    }
    setIsLoadingTenant(true);
    run();
  }, []);

  return { hasProvider, providerTenant, providerName, isLoadingTenant };
}

export default useTenantDetails;
